import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { TaxProfileTemplateInfo } from '../fragments';

export default gql`
  mutation ActionTaxProfileTemplateStatus(
    $input: TaxProfileTemplateStatusActionInput!
  ) {
    actionTaxProfileTemplateStatus(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      taxProfileTemplate {
        ...TaxProfileTemplateInfo
      }
    }
  }
  ${ErrorMessageInfo}
  ${TaxProfileTemplateInfo}
`;
